// @flow
import React, {PureComponent} from 'react';
import {StyleSheet} from 'react-native';
import {withNavigation} from '@react-navigation/compat';
import {FullButton, WarningFrame} from '../../../../components/common';
import I18n from '../../../../lib/i18n';
import theme from '../../../../theme-config';
import * as Navigation from '../../../../lib/navigation.js';

class PendingOrderStatus extends PureComponent<Props> {
  styles = getStyles();
  goToOrders = () => Navigation.navigate('orders');
  yourOrdersButton = () => (
    <FullButton
      textStyle={this.styles.buttonText}
      style={this.styles.button}
      text={I18n.t('Dashboard.Orders.title')}
      onPress={this.goToOrders}
    />
  );
  render() {
    if (!this.props.hasPendingOrders) return null;
    return (
      <WarningFrame
        text={I18n.t('Dashboard.Orders.pendingOrder')}
        Button={this.yourOrdersButton()}
        style={this.props.style}
      />
    );
  }
}

type Props = {style?: any} & StateProps;

export type StateProps = {
  hasPendingOrders: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    buttonText: {
      color: theme.errorColor,
      fontSize: 16,
    },
    button: {
      backgroundColor: 'white',
      marginTop: 12,
      paddingRight: 20,
      paddingLeft: 20,
    },
  });

export default withNavigation(PendingOrderStatus);
